export enum Rating {
  Like = 'like',
  Dislike = 'dislike',
  Dismiss = 'dismiss',
}